// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3WVlh","productName":"Table_productName__11uVd"};